import { useEffect, useState } from "react";
import "../pages/SettingPageuser.css";
import "./EditModalDam.css";
import { useGlobalContext } from "./Context";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import AddAlarmIcon from "@mui/icons-material/AddAlarm";
import { Calendar } from "@hassanmojab/react-modern-calendar-datepicker";
import { addDuration, addOffSet, addTime, addTimeDiff } from "../redux/slices/timeSlice";
import { Close } from "@mui/icons-material";
const moment = require("moment-jalaali");

const TimeModal = ({ penr }) => {
  const { duration, currentTimeDiff,offSet } = useSelector((state) => state.p.time);
  const date = moment(currentTimeDiff);
  const d = date.format("jYYYY-jMM-jDD").split("T")[0].split("-");
  const currentDate = {
    year: +d[0],
    month: +d[1],
    day: +d[2],
  };
  const [confirm, setConfirm] = useState(false);
  const [offset,setOffSet]=useState(offSet);
  const [check, setCkeck] = useState(false);
  const [selectedDay, setSelectedDay] = useState(currentDate);
  const { isAllTimeOpen, openTime, closeTime } = useGlobalContext();
  const [time, setTime] = useState("00:00");
  const [dur, setDur] = useState(duration);
  const dispatch = useDispatch();
  const goToToday = () => {
    const currentDate = moment();
    const date = currentDate.format();
    const formattedDate = currentDate
      .format("YYYY-MM-DDTHH%3Amm%3Ass")
      .replace("M", "")
      .replace("M", "")
      .replace("P", "A")
      .replace("P", "A");
    dispatch(addTime(formattedDate));
    dispatch(addTimeDiff(date));
    window.location.reload();
  };
  useEffect(() => {
    if (check) {
      if (time && selectedDay) {
        const vanilaDate = `${
          selectedDay
            ? `${selectedDay.year}-${selectedDay.month}-${selectedDay.day}T${time}:00:00`
            : ""
        }`;
        const date = moment(vanilaDate, `jYYYY-jMM-jDD h:mm:dd`);
        dispatch(addOffSet(offset));
        dispatch(
          addTime(
            date
              .format("YYYY-MM-DDTHH%3Amm%3Ass")
              .replace("M", "")
              .replace("M", "")
              .replace("P", "A")
              .replace("P", "A")
          )
        );
        dispatch(addTimeDiff(date.format()));
        dispatch(addDuration(dur));
        window.location.reload();
      } else {
        toast.error("مقدار ساعت و تاریخ را انتخاب کنید");
      }
    } else {
      setCkeck(true);
    }
  }, [confirm]);
console.log(offSet,offset);
  return (
    <div
      onClick={closeTime}
      className={`modal-overlay ${isAllTimeOpen && "show-modal"} `}
    >
      <div className="editModalDamCon Ani AllFFFF">
        <div className="closee">
          <Close className="closee" />
        </div>
        <div className="editModalDamConHead">
          <AddAlarmIcon fontSize="large" />
          <h4>زمان دریافت اطلاعات را انتخاب کنید</h4>
        </div>
        
        <div className="SelConn" style={{ width: "100%", height: "40px" }}>
          <label
            for="sele"
            style={{
              whiteSpace: "nowrap",
              fontSize: "13px",
              borderRadius: "10px",
            }}
          >
            آفست
          </label>
          <select
            style={{ fontSize: "12px", padding: "3px" }}
            id="sele"
            name="sele"
            className="selectInp"
            value={offset}
            onChange={(e) => setOffSet(e.target.value)}
          >
            <option value={0}>0</option>
            <option value={1}>1</option>
            <option value={2}>2</option>
            <option value={3}>3</option>
            <option value={4}>4</option>
            <option value={5}>5</option>
            <option value={6}>6</option>
            <option value={7}>7</option>
            <option value={8}>8</option>
            <option value={9}>9</option>
            <option value={10}>10</option>
            <option value={11}>11</option>
            <option value={12}>13</option>
            <option value={14}>14</option>
            <option value={15}>15</option>
            <option value={16}>16</option>
            <option value={17}>17</option>
            <option value={18}>18</option>
            <option value={19}>19</option>
            <option value={20}>20</option>
            <option value={21}>21</option>
            <option value={22}>22</option>
            <option value={23}>23</option>
          </select>
        </div>
        <div
            className="inputContainerSS"
            style={{
              width: "100%",
              height: "40px",
              marginBottom: "0px",
              borderRadius: "10px",
            }}
          >
            <input
              autoComplete="off"
              type="time"
              style={{ padding: "10px", fontSize: "12px" }}
              className="inputSS"
              placeholder="a"
              onChange={(e) => {
                setTime(e.target.value);
              }}
              defaultValue={time}
            />
            <label for=""  style={{fontSize:"10px"}} className={"labelSS"}>
              ساعت
            </label>
          </div>
          <div className="SelConn" style={{ width: "100%", height: "40px" }}>
            <label
              for="sele"
              style={{
                whiteSpace: "nowrap",
                fontSize: "13px",
                borderRadius: "10px",
              }}
            >
              بازه روزانه:
            </label>
            <select
              style={{ fontSize: "12px", padding: "3px" }}
              id="sele"
              name="sele"
              className="selectInp"
              value={dur}
              onChange={(e) => setDur(e.target.value)}
            >
              <option value={30}>30 روز</option>
              <option value={60}>60 روز</option>
              <option value={90}>90 روز</option>
              <option value={120}>120 روز</option>
              <option value={150}>150 روز</option>
              <option value={180}>180 روز</option>
              <option value={210}>210 روز</option>
              <option value={240}>240 روز</option>
              <option value={270}>270 روز</option>
              <option value={300}>300 روز</option>
              <option value={330}>330 روز</option>
              <option value={360}>360 روز</option>
            </select>
          </div>
        <Calendar value={selectedDay} onChange={setSelectedDay} locale="fa" />

        <button
          className="EditMOdalBtnForm"
          onClick={() => {
            goToToday();
          }}
        >
          برو به امروز
        </button>
        <button
          className="EditMOdalBtnForm"
          onClick={() => {
            setConfirm(!confirm);
          }}
        >
          تایید
        </button>
      </div>
    </div>
  );
};
export default TimeModal;
